import React from 'react';

function HomeIndex(props){
    return <div>Home Component</div>
}
export default HomeIndex;